/**
 * @fileoverview gRPC-Web generated client stub for integratedapp
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.integratedapp = require('./integratedapp_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.integratedapp.IntegratedAppsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.integratedapp.IntegratedAppsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.integratedapp.NotifyRequest,
 *   !proto.integratedapp.NotifyResponse>}
 */
const methodDescriptor_IntegratedApps_Notify = new grpc.web.MethodDescriptor(
  '/integratedapp.IntegratedApps/Notify',
  grpc.web.MethodType.UNARY,
  proto.integratedapp.NotifyRequest,
  proto.integratedapp.NotifyResponse,
  /**
   * @param {!proto.integratedapp.NotifyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.integratedapp.NotifyResponse.deserializeBinary
);


/**
 * @param {!proto.integratedapp.NotifyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.integratedapp.NotifyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.integratedapp.NotifyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.integratedapp.IntegratedAppsClient.prototype.notify =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/integratedapp.IntegratedApps/Notify',
      request,
      metadata || {},
      methodDescriptor_IntegratedApps_Notify,
      callback);
};


/**
 * @param {!proto.integratedapp.NotifyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.integratedapp.NotifyResponse>}
 *     Promise that resolves to the response
 */
proto.integratedapp.IntegratedAppsPromiseClient.prototype.notify =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/integratedapp.IntegratedApps/Notify',
      request,
      metadata || {},
      methodDescriptor_IntegratedApps_Notify);
};


module.exports = proto.integratedapp;

